<app-header></app-header>
<div class="success">
  <div class="container-12 pr-32px desktop">
    <div class="row align-items-center">
      <div class="col center">
        <img src="../../../assets/img/completed-img.png" alt="">
      </div>
      <div class="col-5 center">
        <div class="row">
          <div class="col">
            <img src="../../../assets/icons/MOBILE/Grupo 231.png" alt="">
          </div>
        </div>
        <div class="row pt-24px">
          <div class="col">
            <span class="f-50 f-d-blue f-bold">
              {{i18n.SUCCESS.PRONTO}}!
              <br>
              {{i18n.SUCCESS.DOCUMENTO_ASSINADO}}.
            </span>
          </div>
        </div>
        <div class="row pt-24px">
          <div class="col">
            <span class="f-20 ">
              {{i18n.SUCCESS.QUANDO_TODAS_AS_PARTES_ASSINAREM}}
              <br>
              {{i18n.SUCCESS.FACILITE_SUAS_ASSINATURAS}}
            </span>
          </div>
        </div>
        <div class="row pt-24px">
          <div class="col bordered-top-bottom f-20">
            <span class="f-d-blue">
              {{i18n.SUCCESS.CHAVE_DOCUMENTO}}
            </span>
            <br>
            <span class="opacited">
              {{signedId}}
            </span>
          </div>
        </div>
        <div class="row pt-24px justify-content-center">
          <div class="col-8">
            <span class="f-blue f-bold f-24">
              {{i18n.SUCCESS.CONTRATE_A_GO}}
            </span>
          </div>
        </div>
        <div class="row pt-24px justify-content-center pb-32px">
          <div class="col-9">
            <button class="btn btn-yellow" (click)="goToLink()">
              {{i18n.SUCCESS.CRIAR_CONTA}}
            </button>
          </div>
        </div>
      </div>
      <div class="col-1 p-0"></div>
    </div>
  </div>
  <div class="container-12 pt-20px mobile center">
    <div class="row">
      <div class="col">
        <img src="../../../assets/icons/MOBILE/Grupo 231.png" alt="">
      </div>
    </div>
    <div class="row pt-24px">
      <div class="col">
        <span class="f-30 f-d-blue f-bold">
          {{i18n.SUCCESS.PRONTO}}!
          <br>
          {{i18n.SUCCESS.DOCUMENTO_ASSINADO}}.
        </span>
      </div>
    </div>
    <div class="row pt-24px">
      <div class="col">
        <span class="f-14 ">
          {{i18n.SUCCESS.QUANDO_TODAS_AS_PARTES_ASSINAREM}}
          <br>
          {{i18n.SUCCESS.FACILITE_SUAS_ASSINATURAS}}
        </span>
      </div>
    </div>
    <div class="row pt-24px">
      <div class="col bordered-top-bottom f-14">
        <span class="f-d-blue">
          {{i18n.SUCCESS.CHAVE_DOCUMENTO}}
        </span>
        <br>
        <span class="opacited">
          {{signedId}}
        </span>
      </div>
    </div>
    <div class="row pt-24px justify-content-center">
      <div class="col-8">
        <span class="f-blue f-bold f-14">
          {{i18n.SUCCESS.CONTRATE_A_GO}}
        </span>
      </div>
    </div>
    <div class="row pt-24px justify-content-center pb-32px">
      <div class="col-9">
        <button class="btn btn-yellow f-12px-m" (click)="goToLink()">{{i18n.SUCCESS.CRIAR_CONTA}}</button>
      </div>
    </div>
  </div>
</div>
